/* jshint esnext: true */
import { $html } from './utils/environment';
import { detectIE } from './utils/is';
import TransitionManager from './transitions/TransitionManager';
import './utils/polyfill'
import svg4everybody from 'svg4everybody';

export default function(firstBlood) {
    svg4everybody();

    if (firstBlood) {
        const transitionManager = new TransitionManager();
    }

    let IE = detectIE()
    if(IE) {
        $html.toggleClass('is-ie', true)
        $html.toggleClass('is-ie-'+IE, true)
    }
}
